
import React from "react";

interface AccountEmailProps {
  email: string | null | undefined;
}

export const AccountEmail = ({ email }: AccountEmailProps) => {
  return (
    <div className="space-y-1">
      <p className="text-sm font-medium">Email</p>
      <p className="text-sm text-gray-500">
        {email || "No email available"}
      </p>
    </div>
  );
};
